/*jshint esversion: 6 */

import React from 'react';
import Slider from "react-slick";

class CaSlideGallery extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            itemsToShow : this.getItemsToShow()
        };
        this.handleResize = this.handleResize.bind(this);
    }
    getWindowWidth() {
        const w=window,
            d=document,
            e=d.documentElement,
            g=d.getElementsByTagName('body')[0],
            x=w.innerWidth||e.clientWidth||g.clientWidth;
        return x;
    }
    getItemsToShow() {
        if (this.getWindowWidth() < 768) {
            return 2;
        }
        return 4;
    }
    componentDidMount(){
        window.addEventListener('resize', this.handleResize);
    }
    componentWillUnmount() {
        window.removeEventListener('resize',this.handleResize);
    }
    handleResize() {
        if (
            (this.state.itemsToShow == this.getItemsToShow())

        ) return;
        this.setState({
            itemsToShow:this.getItemsToShow(),
        });
    }

    render() {
        const { title, items, classNamePrepend, body, noHover } = this.props;
        const { itemsToShow } = this.state;
        const settings = {
            dots: false,
            arrows: false,
            autoplay: false,
            centerMode: false,
            draggable: true,
            infinite: false,
            speed: 500,
            slidesToShow: itemsToShow,
            slidesToScroll: 1
        };
        return(
            <div className={"SlideGallery "+classNamePrepend+(noHover?" SlideGallery--noHover":"")}>
                <div className={"SlideGallery__wrapper "+classNamePrepend+"__wrapper"}>
                    <h2 className={"SlideGallery__title "+classNamePrepend+"__title"}>{title}</h2>
                    {!!body && <p className={"SlideGallery__title "+classNamePrepend+"__body"}>{body}</p> }
                    <div className={"SlideGallery__inner "+classNamePrepend+"__inner"}>
                        <Slider {...settings} >
                            { items }
                        </Slider>
                    </div>
                </div>
            </div>
        )
    }
}

export default CaSlideGallery;





